import { BoxManagementBloc } from "./bloc.box";
import { CloudManagementBloc } from "./bloc.cloud";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseManagementBloc } from "./bloc.base";
import environment from "@/config";

export default getService<BaseManagementBloc>(environment.nexus, {
    box: new BoxManagementBloc(),
    cloud: new CloudManagementBloc(),
});